export const SubHeaderConstants = {
  SUBHEADER_SET_PAGE_TITLE: 'SUBHEADER_SET_PAGE_TITLE',
};
